module.exports = __webpack_public_path__ + "static/media/7.ef68ce3d.JPG";